import { Link, Route, Routes } from 'react-router-dom'

import { AppLayout } from './components/AppLayout'
import { PublicLayout } from './components/PublicLayout'
import {
  ForgotPassword,
  Login,
  Register,
  ResetPassword,
  VerifyEmail,
} from './pages/Auth'
import { Docs } from './pages/Docs'
import { Generator } from './pages/Generator'
import { Landing } from './pages/Landing'
import { Legal } from './pages/Legal'
import { Pricing } from './pages/Pricing'
import { Standard } from './pages/Standard'
import { ApiKeys } from './pages/app/ApiKeys'
import { Billing } from './pages/app/Billing'
import { History } from './pages/app/History'
import { Overview } from './pages/app/Overview'
import { Settings } from './pages/app/Settings'
import { Usage } from './pages/app/Usage'

export function App() {
  return (
    <Routes>
      {/* -------------------------------------------------------- public */}
      <Route element={<PublicLayout />}>
        <Route index element={<Landing />} />
        <Route path="generator" element={<Generator />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="docs" element={<Docs />} />
        <Route path="standard" element={<Standard />} />
        <Route path="terms" element={<Legal kind="terms" />} />
        <Route path="privacy" element={<Legal kind="privacy" />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* ---------------------------------------------------------- auth */}
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="verify-email" element={<VerifyEmail />} />

      {/* ----------------------------------------------------- dashboard */}
      <Route path="app" element={<AppLayout />}>
        <Route index element={<Overview />} />
        <Route path="keys" element={<ApiKeys />} />
        <Route path="usage" element={<Usage />} />
        <Route path="history" element={<History />} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  )
}

function NotFound() {
  return (
    <div className="container-page grid place-items-center py-32 text-center">
      <p className="text-6xl font-bold text-brand-600">404</p>
      <h1 className="mt-4 text-2xl font-bold tracking-tight">Сторінку не знайдено</h1>
      <p className="mt-2 max-w-md text-slate-600 dark:text-slate-400">
        Можливо, посилання застаріло. Спробуйте почати з головної або відкрийте генератор.
      </p>
      <div className="mt-8 flex gap-3">
        <Link to="/" className="btn-primary">
          На головну
        </Link>
        <Link to="/generator" className="btn-secondary">
          Генератор
        </Link>
      </div>
    </div>
  )
}
